var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1751_6624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0005L12 12.0005M12 12.0005L7.99999 16.0005M12 12.0005V21.0005M20.39 18.3905C21.3653 17.8587 22.1358 17.0174 22.5799 15.9991C23.0239 14.9808 23.1162 13.8437 22.8422 12.7672C22.5682 11.6906 21.9435 10.736 21.0667 10.0539C20.1898 9.37185 19.1109 9.00121 18 9.00047H16.74C16.4373 7.82971 15.8732 6.74281 15.0899 5.82147C14.3067 4.90012 13.3248 4.16832 12.2181 3.68108C11.1113 3.19384 9.90854 2.96383 8.70011 3.00835C7.49167 3.05288 6.30906 3.37077 5.24117 3.93814C4.17328 4.5055 3.2479 5.30758 2.53461 6.28405C1.82132 7.26053 1.33868 8.38601 1.12297 9.57587C0.90726 10.7657 0.964096 11.989 1.2892 13.1537C1.61431 14.3185 2.19923 15.3943 2.99999 16.3005",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1751_6624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.567a7ae42b71834891be352d09afe1c2.svg";
export { ForwardRef as ReactComponent };